import React from 'react'
import { Text, View, Modal, Pressable, Dimensions, TouchableOpacity, FlatList } from 'react-native'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faMicrophone, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
import { toqueColor, white } from '../../../theme/colors'
import { globalStyle } from '../../../theme/global'
import { Pulse } from './Pulse'
import { styles } from './styles'
import { OptionsItem } from './Options'
import { Separator } from '../../Separator'

const WIDTH_WINDOW = Dimensions.get('window').width

interface Props {
  handleStarted: (value: boolean) => void
  getValue: (value: string) => void
  handleVoiceMode: (value: boolean) => void
  started: boolean
  startListening: () => Promise<void>
  stopListening: () => Promise<void>
  voiceError: boolean
  voiceMode: boolean
  voiceResults: string[]
}
export const SearchingPage = ({
  handleStarted,
  getValue,
  handleVoiceMode,
  started,
  startListening,
  stopListening,
  voiceError,
  voiceMode,
  voiceResults = [],
}: Props) => {
  const { t } = useTranslation()

  return (
    <Modal
      animationType='fade'
      transparent
      visible={voiceMode}
      style={{
        marginTop: 10,
      }}
      statusBarTranslucent
    >
      <View style={[globalStyle.center, { backgroundColor: 'transparent' }]}>
        <View style={[styles.container, { width: WIDTH_WINDOW }]}>
          <TouchableOpacity onPress={stopListening}>
            <FontAwesomeIcon icon={faTimes} color={toqueColor} size={40} />
          </TouchableOpacity>
          <View style={{ paddingBottom: 300, padding: 30 }}>
            {voiceResults && voiceResults.length !== undefined && (
              <FlatList
                data={voiceResults}
                renderItem={({ item }) => (
                  <OptionsItem
                    onPress={() => {
                      getValue(item)
                      handleStarted(false)
                      handleVoiceMode(false)
                    }}
                    word={item}
                  />
                )}
                ItemSeparatorComponent={Separator}
              />
            )}
          </View>

          <View
            style={[
              styles.containerBottom,
              {
                width: WIDTH_WINDOW,
              },
            ]}
          >
            <Text style={styles.helpTextsPrimary}>
              {started && t('Habla ahora')}
              {!started && voiceError && t('No lo he entendido')}
              {!started && !voiceError && t('Presione para iniciar')}
            </Text>

            <View style={[globalStyle.center, { marginBottom: 90 }]}>
              <View style={styles.containerMic}>
                <Pressable
                  style={[globalStyle.center, styles.microphone]}
                  onPress={() => !started && startListening()}
                >
                  {started && (
                    <TouchableOpacity style={styles.circleStop} onPress={stopListening} />
                  )}
                  {!started && <FontAwesomeIcon icon={faMicrophone} color={white} size={40} />}
                </Pressable>
              </View>
              {started && <Pulse repeat delay={0} />}
            </View>

            <Text style={styles.helpTextsSecondary}>
              {!started && voiceError && t('Pulsa para intentarlo de nuevo')}
              {!started && !voiceError && t('Pulsa para activar microfono')}
            </Text>
          </View>
        </View>
      </View>
    </Modal>
  )
}
